<template>
  <el-row
    :gutter="16"
    type="flex"
    class="category-items-grid d-flex-wrap"
    data-test="d-flex">
    <el-col
      v-for="(item, index) in categoryItems"
      :key="index"
      :lg="{span: 6}"
      :md="{span: 5}"
      :sm="{span: 4}"
      :xs="{span: 3}"
      data-test="list-category-detail">
      <category-item
        :key="index"
        :item-info="item"
        :bucket="bucket"
        data-test="podcast-category"/>
    </el-col>
  </el-row>
</template>
<script>
import CategoryItem from './CategoryItem';

export default {
  name: 'CategoryItemsGrid',
  components: {
    'category-item': CategoryItem,
  },
  props: {
    categoryItems: {
      type: Array,
      default: () => [],
    },
    bucket: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
.category-items-grid {
  .el-col {
    // margin-bottom: 30px;
  }
  @media(min-width: $lg) {
    .el-col-lg-6 {
      width: 16.66% !important;
    }
  }
  @media (max-width: $lg) {
    .el-col-md-5 {
      width: 20% !important;
    }
  }
  @media (max-width: $md) {
    .el-col-sm-4 {
      width: 25% !important;
    }
  }
  @media (max-width: $sm) {
    .el-col-xs-3 {
      width: 33% !important;
    }
  }

  .picture-component {
    height: auto !important;
  }
}
</style>
